export default "__VITE_ASSET__mkFaUK0f__"